import ComponentInit from './utils/ComponentInit';
import SearchBlock from '4-sections/SearchSection/SearchBlock';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { SearchBlock };

export default ComponentInit(componentList);
